import { IHomepageCouponItem } from "interfaces";
import { SwitchButton } from "components/switchButton";
import { Link } from "react-router-dom";
import Button from "components/button";
import { EyeIcon, PencilIcon } from "@heroicons/react/outline";
import { isHaveActionPermission } from "utills/helpers";

interface HomepageCouponCardProps {
  data?: IHomepageCouponItem[];
  pageSize: number;
  currentPage: number;
  _toggleActive: (id: string, isActive: boolean) => void;
}

export const HomepageCouponCard = ({
  data = [],
  pageSize = 10,
  currentPage = 1,
  _toggleActive,
}: HomepageCouponCardProps) => {
  return (
    <ul className="bg-white">
      {data.map((item: IHomepageCouponItem, index: number) => (
        <div
          key={index}
          className="flex flex-col gap-y-4 overflow-hidden shadow-md ring-1 ring-gray-900/5 [&:not(:last-child)]:mb-4 p-4 rounded-xl"
        >
          <div className="w-full flex items-center justify-between">
            <SwitchButton
              checked={item.is_active}
              disabled={!isHaveActionPermission("homepage_coupon", "mkt", "edit")}
              onChange={() => _toggleActive(item.id, item.is_active)}
            />

            <div className="flex items-center gap-x-[8px]">
              <Link to={`/mkt/homepage-coupon/${item.id}`} className="w-fit">
                <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                  <EyeIcon className="w-4 h-4 text-black" />
                </Button>
              </Link>
              {isHaveActionPermission("homepage_coupon", "mkt", "edit") ? (
                <Link
                  to={`/mkt/homepage-coupon/${item.id}/edit`}
                  className="w-fit"
                >
                  <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                    <PencilIcon className="w-4 h-4 text-black" />
                  </Button>
                </Link>
              ) : (
                <></>
              )}
            </div>
          </div>

          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">No</p>
            <p className="flex-1 text-right text-sm leading-6">
              {(currentPage - 1) * pageSize + 1 + index}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Coupon code</p>
            <p className="flex-1 text-right text-sm leading-6">
              {item.coupon_code}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Title
            </p>
            <p className="flex-1 text-right text-sm leading-6 capitalize">
              {item.title_en}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Content</p>
            <p className="flex-1 text-right text-sm leading-6 whitespace-pre-line">
              {item.content_en}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Soldout</p>
            <p className="flex-1 text-right text-sm leading-6">
              {item.is_sold_out ? "Yes" : "No"}
            </p>
          </li>
        </div>
      ))}
    </ul>
  );
};
